import * as React from 'react';
export const TableHead = ({ as = 'thead', ...rest }) => {
    return React.createElement(as, {
        role: as !== 'thead' ? 'rowgroup' : undefined,
        ...rest,
    });
};
